import React from 'react';
import PropTypes from 'prop-types';
import { OptionSelector } from 'components';

const InitialScreenOption = ({ onChange, value }) => {
  const values = [
    { value: 'login', label: 'login' },
    { value: 'signUp', label: 'signUp' },
    { value: 'forgotPassword', label: 'forgotPassword' }
  ];

  return (
    <li className="line-row">
      <span>
        initialScreen:
        <OptionSelector
          name="initialScreen"
          onChange={onChange}
          options={values}
          value={value}
        />
      </span>
    </li>
  );
};

InitialScreenOption.propTypes = {
  onChange: PropTypes.func.isRequired,
  value: PropTypes.string.isRequired
};

export default InitialScreenOption;



// WEBPACK FOOTER //
// ./src/components/EditorOption/InitialScreenOption.js


// WEBPACK FOOTER //
// webpack:///src/components/EditorOption/InitialScreenOption.js